import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PLAYSTORE_LINK, APPSTORE_LINK } from './Constants'

@Component({
  selector: 'app-appurl',
  templateUrl: './app-url.component.html'
})
export class AppUrlComponent implements OnInit {

  content: any
  constructor(
    public router: Router,
  ) { 
  }


  ngOnInit(): void {
    this.redirectToAppStore();
  }

  redirectToAppStore(): void {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      // iOS redirection
      window.location.href = APPSTORE_LINK;
    } else {
      // Fallback redirection if the user agent is unknown
      window.location.href = PLAYSTORE_LINK;
    }
  }

}
